export const pricingPlans = [
  {
    id: 'monthly',
    key: 'pricing.monthly',
    priceKey: 'pricing.monthlyPrice',
    periodKey: 'pricing.perMonth',
    featuresKey: 'pricing.monthlyFeatures',
    highlighted: false,
    icon: 'ri-calendar-line',
  },
  {
    id: 'yearly',
    key: 'pricing.yearly',
    priceKey: 'pricing.yearlyPrice',
    periodKey: 'pricing.perYear',
    featuresKey: 'pricing.yearlyFeatures',
    highlighted: true,
    badgeKey: 'pricing.bestOffer',
    icon: 'ri-vip-crown-line',
  },
  {
    id: 'kids',
    key: 'pricing.kids',
    priceKey: 'pricing.kidsPrice',
    periodKey: 'pricing.perMonth',
    featuresKey: 'pricing.kidsFeatures',
    highlighted: false,
    icon: 'ri-sun-line',
  },
];